import videojs from "video.js";

const Button = videojs.getComponent("Button");
const FullscreenToggle = videojs.getComponent("FullscreenToggle");

export class BackwardButton extends Button {
  constructor(player, options) {
    super(player, options);
    this.handleClick.bind(this);
  }

  createEl() {
    const button = videojs.dom.createEl("button", {
      className: "vjs-backward-button",
    });
    button.ariaLabel = "backward-button";

    button.appendChild(
      videojs.dom.createEl("span", {
        className: "vjs-icon-placeholder",
      }),
    );

    return button;
  }

  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();

    const player = this.player();
    player.currentTime(player.currentTime() - 10);
  }
}

export class ForwardButton extends Button {
  constructor(player, options) {
    super(player, options);
    this.handleClick.bind(this);
  }

  createEl() {
    const button = videojs.dom.createEl("button", {
      className: "vjs-forward-button",
    });
    button.ariaLabel = "forward-button";

    button.appendChild(
      videojs.dom.createEl("span", {
        className: "vjs-icon-placeholder",
      }),
    );

    return button;
  }

  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();

    const player = this.player();
    player.currentTime(player.currentTime() + 10);
  }
}

export const registerPlayerComponents = () => {
  videojs.registerComponent("FullscreenToggle", FullscreenToggle);
  videojs.registerComponent("backwardButton", BackwardButton);
  videojs.registerComponent("forwardButton", ForwardButton);
};
